import React, { Component } from 'react';
import Gravatar from 'react-gravatar';
import { inject, observer } from 'mobx-react';
import BookingTableRow from './BookingTableRow';
import { get, post } from 'axios';
import { isEmpty, noop } from '../../utils';
import Modal from 'react-bootstrap4-modal';
import Notifications8, {notify} from 'react-notify-toast';
import BookingQuickview from './BookingQuickview';
import BookingServices from './BookingServices';
import BookingScheduler from './BookingScheduler';
import BookingInvoice from './BookingInvoice';
import PerfectScrollbar from 'react-perfect-scrollbar';
import 'react-perfect-scrollbar/dist/css/styles.css';
import {Calendar, momentLocalizer} from 'react-big-calendar';
import moment from 'moment';
import 'react-big-calendar/lib/css/react-big-calendar.css'
import momenttz from 'moment-timezone';

const localizer = momentLocalizer(momenttz);

@inject('userStore')
@observer
class Bookings extends Component {
    constructor(props){
        super(props);
        this.state = {
            original_list:[],
            booking_list: [],
            visible:false,
            modalTitle:'Test Title',
            component:null,
            booking:null,
            servicesBooking:null,
            servicesComponent:null,
            quickviewBooking:null,
            bookingInvoice:null,
            activeTab:'active',
            quickviewVisible:false,
            searchValue:'',
            artist_list:[],
            events:[],
            height: 0,
            bus_service_list:[],
            loading:false
        }
        this.fetchBookings = this.fetchBookings.bind(this);
        this.modalBackgroundClicked = this.modalBackgroundClicked.bind(this);
        this.modalHandler = this.modalHandler.bind(this);
        this.back = this.back.bind(this);
        this.setActiveTab = this.setActiveTab.bind(this);
        this.quickviewHandler = this.quickviewHandler.bind(this);
        this.sortBy = this.sortBy.bind(this);
        this.sortByLastname = this.sortByLastname.bind(this);
        this.sortByAge = this.sortByAge.bind(this);
        this.sortByEventdate = this.sortByEventdate.bind(this);
        this.valueChange = this.valueChange.bind(this);
        this.clearSearch = this.clearSearch.bind(this);
        this.closeHandler = this.closeHandler.bind(this);
        this.servicesHandler = this.servicesHandler.bind(this);
        this.scheduleHandler = this.scheduleHandler.bind(this);
        this.invoiceHandler = this.invoiceHandler.bind(this);
        this.createInvoiceHandler = this.createInvoiceHandler.bind(this);
    }

    componentDidMount() {
        this.fetchBookings('active');
        const height = this.divElement.clientHeight;
        this.setState({ height });
    }

    setActiveTab(tab){
      this.fetchBookings(tab);
      this.setState({
          activeTab:tab
      })
    }

    valueChange(event){
        this.setState({searchValue: event.target.value}, () => {
            // filter the array
            this.setState({
                booking_list:this.state.original_list
            }, () => {
                if (this.state.searchValue.length > 2){
                    var searchList = this.state.booking_list.filter((booking) =>
                        booking.email.toLowerCase().includes(this.state.searchValue.toLowerCase()) |
                        booking.full_name.toLowerCase().includes(this.state.searchValue.toLowerCase()) |
                        booking.location_name.toLowerCase().includes(this.state.searchValue.toLowerCase()) |
                        booking.phone.toLowerCase().includes(this.state.searchValue.toLowerCase())
                    );
                    this.setState({
                        booking_list:searchList
                    });
                }
            })
        });
    }

    clearSearch(){
        this.setState({
            searchValue:'',
            booking_list:this.state.original_list
        })
    }

    sortBy(sortType){
        switch (sortType) {
            case 'LASTNAME':
                this.setState({
                    booking_list:this.state.booking_list.sort(this.sortByLastname)
                })
                break;
            case 'AGE':
                this.setState({
                    booking_list:this.state.booking_list.sort(this.sortByAge)
                })
                break;
            case 'EVENTDATE':
                this.setState({
                    booking_list:this.state.booking_list.sort(this.sortByEventdate)
                })
                break;
            default:

        }
    }

    sortByLastname(a,b) {
        if (a.last_name < b.last_name)
            return -1;
        if (a.last_name > b.last_name)
            return 1;
        return 0;
    }

    sortByEventdate(a,b) {
        if (a.days_until < b.days_until)
            return -1;
        if (a.days_until > b.days_until)
            return 1;
        return 0;
    }

    sortByAge(a,b) {
        if (a.age_minutes < b.age_minutes)
            return -1;
        if (a.age_minutes > b.age_minutes)
            return 1;
        return 0;
    }

    quickviewHandler(booking){
      this.quickviewHandlerByHash(booking.hash_id);
      // post('v2/get/booking', {
      //     booking_hash_id: booking.hash_id
      //   }, {
      //     auth: {username: this.props.userStore.token}
      // }).then((res) => {
      //     if (res.data.errors === 0){
      //       if (this.state.quickviewVisible && this.state.quickviewBooking !== booking){
      //         this.setState({
      //           quickviewBooking:res.data.booking
      //         })
      //       } else {
      //         this.setState({
      //           quickviewVisible:!this.state.quickviewVisible,
      //           quickviewBooking:res.data.booking
      //         })
      //       }
      //     } else {
      //       alert(res.data.message);
      //     }
      // }).catch((error) => {
      //   console.log(error);
      //   return error;
      // });
    }

    quickviewHandlerByHash = (hash_id) => {
      post('v2/get/booking', {
          booking_hash_id: hash_id
        }, {
          auth: {username: this.props.userStore.token}
      }).then((res) => {
          if (res.data.errors === 0){
            if (this.state.quickviewVisible && this.state.quickviewBooking !== res.data.booking){
              this.setState({
                quickviewBooking:res.data.booking
              })
            } else {
              this.setState({
                quickviewVisible:!this.state.quickviewVisible,
                quickviewBooking:res.data.booking
              })
            }
          } else {
            alert(res.data.message);
          }
      }).catch((error) => {
        console.log(error);
        return error;
      });

    }


    modalBackgroundClicked(){
        this.setState({
            visible:!this.state.visible, component:null
        });
    }

    modalHandler(booking, component, title){
        this.setState({
            booking:booking,
            component:component,
            visible:!this.state.visible,
            modalTitle:title
        })
    }

    back(){
        this.setState({
            servicesBooking:null,
            servicesComponent:null,
            component:null
        })
    }

    invoiceHandler(invoice, booking){
        this.setState({
            servicesBooking:booking,
            visible:!this.state.visible,
            servicesComponent:<BookingInvoice backHandler={this.back} booking={booking} invoice={invoice}/>
        })
    }

    createInvoiceHandler(booking, sys_invoice_type_id){
        // create invoice and call invoiceHandler
        post('/v2/create/invoice', {bk_hash_id: booking.hash_id, sys_invoice_type_id:sys_invoice_type_id}, {
            auth: {username: this.props.userStore.token}
        }).then((res) => {
            if (res.data.invoice){
              // // add to booking invoice list
              // let temp_booking_list = Object.assign([], this.state.booking_list);
              // let index = this.state.booking_list.findIndex(x => x.id == booking.id);
              // let tmp_booking = Object.assign({}, this.state.booking_list[index]);
              // tmp_booking.bk_invoice_list
              //
                this.invoiceHandler(res.data.invoice, booking);
            }
        }).catch((error) => {
            console.log(error);
            return error;
        });

    }

    servicesHandler(booking){
        this.setState({
            servicesBooking:booking,
            servicesComponent:<BookingServices backHandler={this.back} booking={booking} deleteServiceHandler={this.deleteService} addServiceHandler={this.addService} bus_service_list={this.state.bus_service_list}/>
        })
    }

    scheduleHandler(booking){
        this.setState({
            servicesBooking:booking,
            servicesComponent:<BookingScheduler backHandler={this.back} booking={booking} height={this.state.height}/>
        })
    }

    selectEventByHash = (hash_id) => {
      // console.log(hash_id);
      // console.log(this.state.booking_list);
      //   let index = this.state.booking_list.findIndex(x => x.hash_id == hash_id);
      //   let booking = this.state.booking_list[index];
      this.quickviewHandlerByHash(hash_id);
    }


    selectEvent = (event) => {
        let index = this.state.booking_list.findIndex(x => x.id === event.id);
        let booking = this.state.booking_list[index];
        this.quickviewHandler(booking);
      }


    closeHandler(){
        this.setState({
            quickviewVisible:false
        })
    }

    deleteService = (service) => {
      let temp_service = Object.assign({}, this.state.servicesBooking);
      let s_index = temp_service.service_list.findIndex(x => x.id === service.id);
      temp_service.service_list.splice(s_index, 1);
      let temp_booking_list = Object.assign([], this.state.booking_list);
      let index = this.state.booking_list.findIndex(x => x.id === this.state.servicesBooking.id);
      temp_booking_list[index] = temp_service
      this.setState({
        booking_list:temp_booking_list
      })
    }

    addService = (service) => {
      let temp_service = Object.assign({}, this.state.servicesBooking);
      let s_index = temp_service.service_list.findIndex(x => x.id === service.id);
      temp_service.service_list.push(service);
      let temp_booking_list = Object.assign([], this.state.booking_list);
      let index = this.state.booking_list.findIndex(x => x.id === this.state.servicesBooking.id);
      temp_booking_list[index] = temp_service
      this.setState({
        booking_list:temp_booking_list
      })
    }

    startTimeEdit = (readyTime) => {
      post('/v2/save/ready_time', {bk_hash_id: this.state.quickviewBooking.hash_id, ready_time:readyTime}, {
        auth: {username: this.props.userStore.token}
      }).then((res) => {
        if (res.data.errors === 0){
          let temp_booking = Object.assign({}, this.state.quickviewBooking);
          let temp_booking_list = Object.assign([], this.state.booking_list);
          let index = this.state.booking_list.findIndex(x => x.id === this.state.quickviewBooking.id);
          temp_booking_list[index] = res.data.booking
          this.setState({
            booking_list:temp_booking_list,
            quickviewBooking:res.data.booking
          })
        }
      }).catch((error) => {
          console.log(error);
          return error;
      });
    }

    editBooking = (booking) => {
      post('/v2/save/booking', {booking: booking}, {
        auth: {username: this.props.userStore.token}
      }).then((res) => {
        if (res.data.errors === 0){
          let temp_booking = Object.assign({}, res.data.booking);
          let temp_booking_list = Object.assign([], this.state.booking_list);
          let index = this.state.booking_list.findIndex(x => x.id === res.data.booking);
          temp_booking_list[index] = res.data.booking
          this.setState({
            booking_list:temp_booking_list,
            quickviewBooking:res.data.booking
          })
        }
        alert(res.data.message);
      }).catch((error) => {
          console.log(error);
          return error;
      });

    }

    fetchBookings(activeTab){
      this.setState({loading:true});
      post('v2/get/bookings', {
          filter:activeTab,
          business_hash_id: this.props.userStore.business_primary.hash_id
        }, {
          auth: {username: this.props.userStore.token}
      }).then((res) => {
          res.data.event_list.forEach(function (event) {
              event.start = moment(event.start, moment.ISO_8601).toDate();
              event.end = moment(event.end, moment.ISO_8601).toDate();
          });
          this.setState({
              booking_list:res.data.booking_list,
              original_list:res.data.booking_list,
              events:res.data.event_list,
              bus_service_list:res.data.service_list,
              loading:false
          }, ()=>{
              if (this.props.location.state && this.props.location.state.hash_id){
                  this.selectEventByHash(this.props.location.state.hash_id)
              }
          });
      }).catch((error) => {
        console.log(error);
        return error;
      });
    }

    resetPassword = () => {
      if (this.state.quickviewBooking){
        post('/v2/post/pw_reset', {hash_id:this.state.quickviewBooking.user_hash_id},{
            auth: {username: this.props.userStore.token}
        }).then((res) => {
          if (res.data.errors === 0){
            alert(res.data.message);
          } else {
            alert(res.data.message);
          }
        }).catch((error) => {
          return error;
        });
      }
    }

    resendEmail = () => {
      if (this.state.quickviewBooking){
        post('/v2/post/resend-email', {hash_id:this.state.quickviewBooking.user_hash_id},{
            auth: {username: this.props.userStore.token}
        }).then((res) => {
          if (res.data.errors === 0){
            alert(res.data.message);
          } else {
            alert(res.data.message);
          }
        }).catch((error) => {
          console.log(error);
          return error;
        });
      }
    }

    inactivateHandler = () => {
      this.setActiveTab('inactive');
      this.modalBackgroundClicked();
    }


  render() {
      const { booking_list, original_list, booking } = this.state;
      // BigCalendar.momentLocalizer(moment); // or globalizeLocalizer
      var activeTabComponent = null;
      switch (this.state.activeTab) {
          case "calendar":
                activeTabComponent = (
                    <div id="calendar" className="tab-pane active card card-body mt-20" style={{height:this.state.height - 50 + "px"}}>
                      <Calendar
                        resizable
                        localizer={localizer}
                        events={this.state.events}
                        onSelectEvent={this.selectEvent}
                        defaultDate={new Date()}/>
                    </div>
                );
                break;
          default:
              activeTabComponent = (
                  <div id="active" className="tab-pane active media-list media-list-divided media-list-hover" data-provide="selectall">
                      <table style={{width:100+"%"}}>
                          <tbody className="media-list-body bg-white b-1">
                          {booking_list.map((booking, booking_index) =>
                            <BookingTableRow booking={booking} key={booking_index} qHandler={this.quickviewHandler} handler={this.modalHandler}/>
                          )}
                          </tbody>
                      </table>
                  </div>
              );
              break;
      }


      return (
        <React.Fragment>
            <Modal visible={this.state.visible} onClickBackdrop={() => this.modalBackgroundClicked()} dialogClassName="modal-lg w-900px">
                <Notifications8  options={{wrapperId:'modal-notifications'}} />
                <div className="modal-header">
                    <h4 className="modal-title">{this.state.modalTitle}</h4>
                    <button type="button" className="close" onClick={() => this.modalBackgroundClicked(null)} aria-label="Close">
                      <span aria-hidden="true">×</span>
                    </button>
                </div>
                <div className="modal-body">
                    {this.state.component ? <this.state.component inquiry={this.state.booking} handler={this.modalBackgroundClicked} invoiceHandler={this.invoiceHandler} createInvoiceHandler={this.createInvoiceHandler} inactivateHandler={this.inactivateHandler} notifyHandler={notify}/> : null}
                </div>
                <div className="modal-footer">
                    <button type="button" className="btn btn-secondary" onClick={() => this.modalBackgroundClicked(null)}>
                      Close
                    </button>
                </div>
            </Modal>
            {this.state.servicesBooking && this.state.servicesComponent ?
                this.state.servicesComponent
            :
            <React.Fragment>
            <header className="header mb-0">
                <div className="header-action pt-20">
                    <ul className="nav nav-tabs">
                        <li className="nav-item cursor">
                            <a href="#" className={this.state.activeTab === "active" ? "nav-link active" : "nav-link"} onClick={() => this.setActiveTab('active')}>Active Events</a>
                        </li>
                        <li className="nav-item">
                            <a href="#" className={this.state.activeTab === "past" ? "nav-link active" : "nav-link"} onClick={() => this.setActiveTab('past')}>Past Events</a>
                        </li>
                        <li className="nav-item">
                            <a href="#" className={this.state.activeTab === "inactive" ? "nav-link active" : "nav-link"} onClick={() => this.setActiveTab('inactive')}>Inactive Events</a>
                        </li>
                        <li className="nav-item">
                            <a href="#" className={this.state.activeTab === "calendar" ? "nav-link active" : "nav-link"} onClick={() => this.setActiveTab('calendar')}>Calendar View</a>
                        </li>
                    </ul>
                </div>
            </header>
            <div className="main-content pt-0" ref={ (divElement) => this.divElement = divElement}>
            {this.state.activeTab !== 'calendar' ?
                <header className="flexbox align-items-center media-list-header bg-transparent b-0 py-16 pl-20">
                    <div className="flexbox align-items-center">
                        <div className="dropdown">
                            <a className="btn btn-sm dropdown-toggle" data-toggle="dropdown" href="#">Sort by</a>
                            <div className="dropdown-menu">
                                <a className="dropdown-item" onClick={() => this.sortBy('EVENTDATE')}>Event Date</a>
                                <a className="dropdown-item" onClick={() => this.sortBy('AGE')}>Date Created</a>
                                <a className="dropdown-item" onClick={() => this.sortBy('LASTNAME')}>Name</a>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div className="lookup lookup-circle lookup-right">
                            <input type="text" value={this.state.searchValue} onChange={this.valueChange}/>
                        </div>
                        {this.state.searchValue !== '' ? <button className="ml-10 btn btn-outline btn-sm btn-danger" onClick={this.clearSearch}>Clear</button> : null}
                    </div>
                </header>
            : null}
                <div className="tab-content">
                <PerfectScrollbar>
                {this.state.loading
                  ?
                  <div className="spinner-ball"></div>
                  :
                  !isEmpty(original_list) || this.state.activeTab === 'calendar' ?
                  activeTabComponent
                  : <div className="p-30 fs-25 fw-500 text-center">No Results Found</div>
                }
                </PerfectScrollbar>
                </div>
            </div>
            <div className={this.state.quickviewVisible ? "quickview quickview-lg reveal" : "quickview quickview-lg"}>
            {this.state.quickviewBooking ?
                <BookingQuickview quickviewBooking={this.state.quickviewBooking} closeHandler={this.closeHandler} modalHandler={this.modalHandler} servicesHandler={this.servicesHandler} scheduleHandler={this.scheduleHandler} startTimeHandler={this.startTimeEdit} resetHandler={this.resetPassword} resendHandler={this.resendEmail} editHandler={this.editBooking}/>
              : <div>Loading</div>
            }
            </div>
            </React.Fragment>
            }
        </React.Fragment>
    );
  }
}

export default Bookings;



// WEBPACK FOOTER //
// ./src/components/business/Bookings.js